const REGEXP = {
    validations: {
        email: /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+$/,
        userName: /^[a-zA-Z '"_\-.\u00E0-\u00FC]{2,}$/,
        password: /^[a-zA-Z0-9\-\u00E0-\u00FC]{6,}$/
    },
    path: {
        params: /\/:([a-z0-9]*)/gi
    }
}

export default REGEXP


// WEBPACK FOOTER //
// ./src/constant/REGEXP.js